let map = document.querySelector('.map')

if(map) {
    map.addEventListener('click', () => {
        map.classList.add('clicked')
    })
}